/**
 * Viewport CSS vars and size. Used by reveal-tweaks and fullscreen.
 */

export function getVisibleViewportSize(): { width: number; height: number } {
  const vv = typeof window !== 'undefined' && window.visualViewport;
  if (vv) {
    return {
      width: Math.max(1, Math.round(vv.width)),
      height: Math.max(1, Math.round(vv.height))
    };
  }
  const w = typeof window !== 'undefined' ? window : { innerWidth: 1280, innerHeight: 720 };
  const doc = typeof document !== 'undefined' && document.documentElement;
  return {
    width: Math.max(1, Math.round((w.innerWidth || (doc && doc.clientWidth) || 0))),
    height: Math.max(1, Math.round((w.innerHeight || (doc && doc.clientHeight) || 0)))
  };
}

/**
 * Install CSS custom properties for visual viewport.
 */
export function installViewportBottomInsetVar(): void {
  const root = typeof document !== 'undefined' ? document.documentElement : null;
  if (!root) return;
  const r = root;
  let rafId = 0;

  function updateVar(): void {
    rafId = 0;
    const vv = window.visualViewport;
    let offset = 0;
    let visualHeight = window.innerHeight || r.clientHeight || 0;
    if (vv) {
      const layoutHeight = window.innerHeight || r.clientHeight || 0;
      const visualBottom = vv.height + vv.offsetTop;
      offset = Math.max(0, Math.round(layoutHeight - visualBottom));
      visualHeight = Math.round(vv.height);
    }
    r.style.setProperty('--rf-visual-viewport-bottom', offset + 'px');
    r.style.setProperty('--rf-visual-viewport-height', Math.max(1, visualHeight) + 'px');
  }

  function scheduleUpdate(): void {
    if (rafId) return;
    rafId = requestAnimationFrame(updateVar);
  }

  updateVar();
  window.addEventListener('resize', scheduleUpdate, { passive: true });
  window.addEventListener('orientationchange', scheduleUpdate, { passive: true });
  if (window.visualViewport) {
    window.visualViewport.addEventListener('resize', scheduleUpdate, { passive: true });
    window.visualViewport.addEventListener('scroll', scheduleUpdate, { passive: true });
  }
}
